<div role="status" class="w-full my-1 min-h-[25px] animate-pulse">
    <span class="sr-only">Loading...</span>
    <section class='my-3'>
        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mt-2 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
    </section>
    <section class='my-3'>
        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mt-2 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
    </section>
    <section class='my-3'>
        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mt-2 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
    </section>
    <section class='my-3'>
        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mt-2 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
    </section>
    <section class='my-3'>
        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mt-2 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
    </section>
    <section class='my-3'>
        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mt-2 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-3.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
    </section>
</div>